export var IngestionSinkType;
(function (IngestionSinkType) {
    IngestionSinkType["INGESTION_SINK_TYPE_ICEBERG"] = "ICEBERG";
    IngestionSinkType["INGESTION_SINK_TYPE_PAIMON"] = "PAIMON";
})(IngestionSinkType || (IngestionSinkType = {}));
